import { render, staticRenderFns } from "./NewConversationSetupPage.vue?vue&type=template&id=47bf74c5&scoped=true"
import script from "./NewConversationSetupPage.vue?vue&type=script&lang=js"
export * from "./NewConversationSetupPage.vue?vue&type=script&lang=js"
import style0 from "./NewConversationSetupPage.vue?vue&type=style&index=0&id=47bf74c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bf74c5",
  null
  
)

export default component.exports